<template>
  <div class="details">
    <slot name="prepend" />
    <vs-text v-if="weekViewDoubleHeightJobCard" class="content" type="caption" truncate>
      <div>
        {{ formattedStartTime }}
        <span class="activity_content">{{ cardDescription }}</span>
        <br />
        <div style="display: flex">
          <div class="truncate">{{ formattedPickupLocation }}</div>
          <div>{{ showArrow ? '→' : '' }}</div>
          <div class="truncate">{{ destinationLocation }}</div>
        </div>
      </div>
    </vs-text>
    <vs-text v-else class="content" type="caption" truncate>
      <span
        >{{ formattedStartTime }} <span class="details__location">{{ destinationLocation }}</span> |
        {{ cardDescription }}</span
      >
    </vs-text>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Moment } from 'moment'
import { Item } from '@/components/weekly-schedule/utils'
import { useStore } from 'vuex-composition-helpers'
import { JobStopType } from '@ironsight/types'

const props = defineProps<{
  job: Item
  weekStart: Moment
  description?: string
}>()
const store = useStore()
const weekViewDoubleHeightJobCard = computed<boolean>(
  () => store.getters['featureFlags/weekViewDoubleHeightJobCard'],
)
const formattedStartTime = computed(() => {
  const time = props.job.displayedStartTime.isBefore(props.weekStart)
    ? props.weekStart
    : props.job.displayedStartTime
  return time.toDate().toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  })
})

const cardDescription = computed(() => {
  return props.description ?? props.job.activity?.taskName
})

const formattedPickupLocation = computed(() => {
  const pickupStops = props.job.requestedStops.filter((s) => s.stopType === JobStopType.PickUp)
  if (pickupStops.length > 0) {
    if (pickupStops[0].locationId) {
      return pickupStops[0].locationName ?? ''
    } else {
      return 'TBD'
    }
  } else {
    return ''
  }
})
const showArrow = computed(() => (formattedPickupLocation.value?.length ?? 0) > 0)
const destinationLocation = computed(() => {
  const dropoffStops = props.job.requestedStops.filter((s) => s.stopType === JobStopType.DropOff)
  if (dropoffStops.length > 0 && dropoffStops[0].locationName) {
    return dropoffStops[0].locationName
  } else {
    return ''
  }
})
</script>

<style scoped>
.details {
  display: flex;
  height: 100%;
}
.content {
  padding-block-start: 4px;
}
.activity_content {
  font-weight: bold;
}
.truncate {
  max-inline-size: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
